import React from 'react';
import * as I18n from 'circe/I18n';
import withForm from 'circe/forms/withForm';
import TextField from 'circe/forms/fields/TextField';
import Form from 'circe/forms/components/Form';
import * as Validation from 'circe/forms/validation';
import SelectField from 'circe/forms/fields/SelectField';
import FieldsAclSelection from './FieldsAclSelection';
import TableProperities from './TableProperities';
import { getAclArray } from '../utils';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
// startCase
const Comp = (props) => {
  const { submitting, handleSubmit, onSubmit } = props;
  return (
    <React.Fragment>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        title="Table Reports Creator"
        formGrid={{
          xs: 6,
        }}
        submitting={submitting}
      >
        <TextField
          name="Report name"
          type="text"
          label={I18n.str('reportName', 'Report name')}
          validate={[Validation.required]}
          helpText="Help me filling this out "
        />
        <TextField
          name="dataUrl"
          type="url"
          label={I18n.str('dataUrl', 'Data URL')}
          validate={[Validation.required, Validation.url]}
          helpText="Help me filling this out "
        />
        <SelectField
          label={I18n.str('acl', 'ACL')}
          fullWidth
          multiple
          name="acl"
          options={getAclArray()}
        />
        <FieldsAclSelection />
        <TableProperities />
      </Form>
    </React.Fragment>
  );
};
// export default Comp;
export default withForm({
  form: 'registerationForm',
  goTo: '/dashboard',
  url: 'api/register',
  // remoteData: {
  //   url: 'replyapi/api/agents',
  //   params: {},
  // },
})(Comp);
